// import React, { useEffect } from "react";
import axios from "axios";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchQuestionTypes,
//   fetchDifficultyLevels,
//   setFormDetails,
//   addComprehensionQuestion,
//   addNewQuestion,
//   fetchQuestions,
//   setState,
// } from "./redux/questionBankSlice";
// import { Button } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";

// export default function AddQuestionForm() {
//   const dispatch = useDispatch();
//   const {
//     newQuestion,
//     selectedQuestionTypeId,
//     selectedClassId,
//     selectedSubjectId,
//     selectedChapterId,
//   } = useSelector((state) => state.questionBank);
//   const { user } = useSelector((store) => store.authSlice);
//   const user_id = user.user.id;

//   const { questionText, passageText, subQuestions, options, matchingPairs } =
//     newQuestion;

//   useEffect(() => {
//     dispatch(fetchQuestionTypes());
//     dispatch(fetchDifficultyLevels());
//   }, [dispatch]);

//   const handleArrayUpdate = (key, index, value) => {
//     const updated = [...newQuestion[key]];
//     updated[index] = value;
//     dispatch(setFormDetails({ key, value: updated }));
//   };

//   const handleAddToArray = (key, defaultValue) => {
//     dispatch(
//       setFormDetails({ key, value: [...newQuestion[key], defaultValue] })
//     );
//   };

//   const handleRemoveFromArray = (key, index) => {
//     const updated = [...newQuestion[key]];
//     updated.splice(index, 1);
//     dispatch(setFormDetails({ key, value: updated }));
//   };

//   const handleAddSubQuestion = () => {
//     const subQ = {
//       id: Date.now(),
//       question: "",
//     };
//     dispatch(addComprehensionQuestion(subQ));
//   };

//   const preparePayload = async (q) => {
//     try {
//       const typeId = Number(selectedQuestionTypeId);
//       const payload = {
//         question_text: q.questionText,
//         passage_text: q.passageText || null,
//         question_typeid: typeId,
//         difficulty_id: Number(q.difficulty_level),
//       };

//       if ([1, 2].includes(typeId))
//         payload.options = q.options.map((text) => ({ text }));
//       if (typeId === 8 || typeId === 15) payload.options = [{ text: "" }];
//       if ([3, 4, 5, 9, 10, 12, 13, 14].includes(typeId)) payload.options = [];
//       if (typeId === 11)
//         payload.sub_questions = await Promise.all(
//           q.subQuestions.map(preparePayload)
//         );
//       if (typeId === 16) {
//         payload.matching_options = q.matchingPairs.map((pair) => ({
//           column1_text: pair.column1_text,
//           column2_text: pair.column2_text,
//         }));
//       }

//       await dispatch(
//         addNewQuestion({
//           questionData: payload,
//           classId: selectedClassId,
//           subjectId: selectedSubjectId,
//           chapterId: selectedChapterId,
//           created_by: user_id,
//         })
//       );
//       dispatch(setState({ key: "addNewQuestion", value: false }));

//       dispatch(
//         fetchQuestions({
//           selectedClassId,
//           selectedSubjectId,
//           selectedChapterId,
//           user_id,
//         })
//       );

//       return payload;
//     } catch (error) {
//       console.error("Error in preparePayload:", error);
//       // Optionally, show toast or UI error here
//       return null;
//     }
//   };

//   return (
//     <div className="p-6 max-w-4xl mx-auto">
//       <Button
//         variant="contained"
//         onClick={() =>
//           dispatch(setState({ key: "addNewQuestion", value: false }))
//         }
//       >
//         Close
//       </Button>
//       <h2 className="text-xl text-center font-semibold mb-6">Add Question</h2>
//       {!["Comprehension", "Match the Following"].includes(
//         selectedQuestionTypeId
//       ) && (
//         <div className="mb-4">
//           <label className="block font-semibold text-gray-700 mb-1">
//             Question Text
//           </label>
//           <textarea
//             rows={3}
//             value={questionText}
//             onChange={(e) =>
//               dispatch(
//                 setFormDetails({ key: "questionText", value: e.target.value })
//               )
//             }
//             className="w-full p-2 border border-gray-300 rounded"
//           />
//         </div>
//       )}
//       {/* MCQ Options */}
//       {[1, 2].includes(selectedQuestionTypeId) && (
//         <div className="mb-4">
//           <label className="block font-semibold text-gray-700 mb-2">
//             Options (prefix correct with `*`)
//           </label>
//           {options.map((opt, index) => (
//             <div key={index} className="flex gap-2 mb-2">
//               <input
//                 type="text"
//                 value={opt}
//                 onChange={(e) =>
//                   handleArrayUpdate("options", index, e.target.value)
//                 }
//                 className="flex-1 p-2 border border-gray-300 rounded"
//               />
//               {options.length > 4 && (
//                 <Button
//                   variant="contained"
//                   onClick={() => handleRemoveFromArray("options", index)}
//                   className="text-red-500"
//                 >
//                   ✕
//                 </Button>
//               )}
//             </div>
//           ))}
//           <Button
//             variant="contained"
//             onClick={() => handleAddToArray("options", "")}
//             className="bg-blue-600 text-white mt-2"
//           >
//             ➕ Add Option
//           </Button>
//         </div>
//       )}
//       {/* Comprehension */}
//       {selectedQuestionTypeId === 6 && (
//         <>
//           <div className="mb-4">
//             <label className="block font-semibold text-gray-700 mb-1">
//               Comprehension Passage
//             </label>
//             <textarea
//               value={passageText}
//               onChange={(e) =>
//                 dispatch(
//                   setFormDetails({ key: "passageText", value: e.target.value })
//                 )
//               }
//               className="w-full p-2 border border-gray-300 rounded"
//               rows={5}
//             />
//           </div>

//           <div className="mb-2">
//             <label className="block font-semibold text-gray-700 mb-1">
//               Sub-questions :
//             </label>
//             <Button
//               variant="contained"
//               onClick={handleAddSubQuestion}
//               style={{ marginLeft: "2%" }}
//               className="mt-4 px-4 py-2 bg-green-600 text-white"
//             >
//               Add Sub-Question
//             </Button>
//           </div>

//           {subQuestions.map((subQ, idx) => (
//             <div
//               // className="border p-2 rounded mb-2 items-center"
//               style={{
//                 display: "flex",
//                 gap: "1%",
//                 alignItems: "center",
//                 width: "80%",
//                 marginLeft: "2%",
//               }}
//             >
//               <p>
//                 <strong> {idx + 1}</strong>
//               </p>

//               <input
//                 type="text"
//                 style={{ width: "80%" }}
//                 value={subQ.question}
//                 onChange={(e) => {
//                   const updated = [...subQuestions];
//                   updated[idx].question = e.target.value;
//                   dispatch(
//                     setFormDetails({ key: "subQuestions", value: updated })
//                   );
//                 }}
//                 placeholder="Sub-question text"
//                 className="w-full border p-2 rounded mb-2"
//               />
//               <DeleteIcon
//                 onClick={() => {
//                   const updated = subQuestions.filter((_, i) => i !== idx);
//                   dispatch(
//                     setFormDetails({ key: "subQuestions", value: updated })
//                   );
//                 }}
//                 style={{ cursor: "pointer", color: "red" }}
//               />
//             </div>
//           ))}
//         </>
//       )}
//       {/* Match the Following */}
//       {selectedQuestionTypeId === 16 && (
//         <div className="mt-4">
//           <h4 className="font-semibold text-gray-700 mb-2">Matching Pairs</h4>
//           {Array.isArray(matchingPairs) &&
//             matchingPairs.map((pair, idx) => (
//               <div key={idx} className="flex gap-2 mb-2">
//                 <input
//                   type="text"
//                   value={pair.column1_text}
//                   onChange={(e) => {
//                     const updated = matchingPairs.map((pair, i) =>
//                       i === idx
//                         ? { ...pair, column1_text: e.target.value }
//                         : pair
//                     );
//                     dispatch(
//                       setFormDetails({ key: "matchingPairs", value: updated })
//                     );
//                   }}
//                   placeholder={`Column A - ${idx + 1}`}
//                   className="w-1/2 p-2 border border-gray-300 rounded"
//                 />
//                 <input
//                   type="text"
//                   value={pair.column2_text}
//                   onChange={(e) => {
//                     const updated = matchingPairs.map((pair, i) =>
//                       i === idx
//                         ? { ...pair, column2_text: e.target.value }
//                         : pair
//                     );
//                     dispatch(
//                       setFormDetails({ key: "matchingPairs", value: updated })
//                     );
//                   }}
//                   placeholder={`Column B - ${idx + 1}`}
//                   className="w-1/2 p-2 border border-gray-300 rounded"
//                 />
//               </div>
//             ))}

//           <Button
//             variant="contained"
//             onClick={() =>
//               handleAddToArray("matchingPairs", {
//                 column1_text: "",
//                 column2_text: "",
//               })
//             }
//             className="bg-blue-600 text-white"
//           >
//             ➕ Add Pair
//           </Button>
//         </div>
//       )}
//       <Button
//         onClick={() => {
//           console.log("new Question", newQuestion);
//           const modified = preparePayload(newQuestion);
//           console.log("modified", modified);
//         }}
//       >
//         Save the question
//       </Button>{" "}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import Popup from "./PopUp";
import Select from "react-select";
// Custom Message Box Component
import { useSelector, useDispatch } from "react-redux";
import {
  setEditingQuestion,
  updateQuestion,
  addQuestionsFromFile,
  setSelectedQuestionTypeId,
} from "./redux/questionBankSlice";
import {
  addQuestionThunk,
  editQuestionThunk,
  fetchQuestionsThunk,
} from "./redux/questionBankThunk";
import { uploadImage, getDifficultyLevels, getQuestionTypes } from "./config";
import {
  apiKeyHeader,
  apiKeyHeaderMultiPartFormData,
} from "../../configs/ApiKeys";
import userStore from "../../zustand/userStore";
const MessageBox = ({ message, type, onClose }) => {
  if (!message) return null;

  const bgColor =
    type === "error"
      ? "bg-red-100 border-red-400 text-red-700"
      : "bg-green-100 border-green-400 text-green-700";
  const borderColor = type === "error" ? "border-red-500" : "border-green-500";

  return (
    <div
      className={`fixed top-4 left-1/2 -translate-x-1/2 p-4 rounded-lg shadow-lg z-50 ${bgColor} border ${borderColor} flex items-center justify-between`}
      style={{ minWidth: "300px" }}
    >
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-4 text-lg font-bold leading-none hover:text-gray-900"
      >
        &times;
      </button>
    </div>
  );
};
// const userStr = localStorage.getItem("user");
// const userId = userStr ? JSON.parse(userStr).id : null;
const AddQuestionForm = () => {
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const userId = userData?.id;
  // alert(JSON.stringify(userData));
  const selectedClassId = useSelector((state) => state.chapter.selectedClassId);
  const selectedSubjectId = useSelector(
    (state) => state.chapter.selectedSubjectId
  );

  // const { user } = useSelector((store) => store.authSlice);
  // // const user_id = user.user.id;
  // const user_id = user?.user?.user_id;
  const selectedChapterId = useSelector(
    (state) => state.chapter.selectedChapterId
  );
  const editData = useSelector((state) => state.questionBank.editingQuestion); // Adjust slice name if needed

  const [isProcessing, setIsProcessing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // Regular question states
  const [questionType, setQuestionType] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [options, setOptions] = useState(["", "", "", ""]);
  const [difficultyLevel, setDifficultyLevel] = useState("");

  // Comprehension passage and questions
  const [comprehensionPassage, setComprehensionPassage] = useState("");
  const [comprehensionQuestions, setComprehensionQuestions] = useState([]);

  // Current comprehension sub-question being added
  const [compQuestionType, setCompQuestionType] = useState("");
  const [compQuestionText, setCompQuestionText] = useState("");
  const [compOptions, setCompOptions] = useState(["", "", "", ""]);

  // State for API fetched data
  const [fetchedQuestionTypes, setFetchedQuestionTypes] = useState([]);
  const [fetchedDifficultyLevels, setFetchedDifficultyLevels] = useState([]);
  const [loadingMasterData, setLoadingMasterData] = useState(true);
  const [errorMasterData, setErrorMasterData] = useState(null);

  // State for file upload
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("info");

  // Image upload state: now stores the File object
  const [diagramImage, setDiagramImage] = useState(null);
  // State to store the URL of the uploaded image
  const [diagramImageUrl, setDiagramImageUrl] = useState("");
  const [imageUploading, setImageUploading] = useState(false);

  //Comprehension
  const addSubQuestion = () => {
    setComprehensionQuestions([...comprehensionQuestions, ""]);
  };

  //match the following
  const [matchingPairs, setMatchingPairs] = useState([
    { column1_text: "", column2_text: "" }, // One initial empty pair
  ]);

  // Update individual input fields
  const handleChange = (index, field, value) => {
    const updatedPairs = [...matchingPairs];
    updatedPairs[index][field] = value;
    setMatchingPairs(updatedPairs);
  };

  // Add new empty matching pair
  const addNewPair = () => {
    setMatchingPairs([
      ...matchingPairs,
      { column1_text: "", column2_text: "" },
    ]);
  };

  const removeSubQuestion = (index) => {
    const updated = [...comprehensionQuestions];
    updated.splice(index, 1);
    setComprehensionQuestions(updated);
  };

  const handleSubQuestionChange = (index, value) => {
    const updated = [...comprehensionQuestions];
    updated[index] = value;
    setComprehensionQuestions(updated);
  };

  const resetForm = () => {
    // Clear regular question fields
    setQuestionText("");
    setOptions(["", "", "", ""]);
    setQuestionType(
      fetchedQuestionTypes.length > 0 ? fetchedQuestionTypes[0].type_name : ""
    );
    setDifficultyLevel(
      fetchedDifficultyLevels.length > 0
        ? fetchedDifficultyLevels[0].difficulty_name
        : ""
    );

    // Clear comprehension fields
    setComprehensionPassage("");
    setComprehensionQuestions([]);
    setCompQuestionText("");
    setCompOptions(["", "", "", ""]);
    setCompQuestionType(
      fetchedQuestionTypes.length > 0 ? fetchedQuestionTypes[0].type_name : ""
    );

    // Clear image states
    setDiagramImage(null);
    setDiagramImageUrl(""); // Clear the URL as well
    setImageUploading(false);

    // Clear messages
    setMessage(null);
    setMessageType("info");
    dispatch(setEditingQuestion(null));
    setShowModal(false);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setDiagramImage(file); // Store the file object
      setImageUploading(true);
      setMessage("Uploading image...");
      setMessageType("info");

      const formData = new FormData();
      formData.append("image", file); // 'image' should match the field name expected by your backend

      try {
        const response = await axios.post(uploadImage, formData, {
          headers: apiKeyHeaderMultiPartFormData(),
        });
        const result = response?.data;
        setDiagramImageUrl(result.imageUrl);
        setMessage("Image uploaded successfully!");
        setMessageType("success");
      } catch (err) {
        console.error("Error uploading image:", err);
        setMessage(`Failed to upload image: ${err.message}`);
        setMessageType("error");
        setDiagramImage(null); // Clear the image if upload fails
        setDiagramImageUrl("");
      } finally {
        setImageUploading(false);
      }
    }
  };

  useEffect(() => {
    if (editData) {
      console.log("Edit data", editData);
      setQuestionType(editData.type_name || "");
      setQuestionText(editData.question_text || "");
      setOptions(
        editData.options && editData.options.length > 0
          ? editData.options.map((opt) => opt.text)
          : ["", "", "", ""]
      );
      if (editData.matching_options && editData.matching_options.length > 0) {
        setMatchingPairs(
          editData.matching_options.map((pair) => ({
            column1_text: pair.column1_text,
            column2_text: pair.column2_text,
          }))
        );
      }
      setDifficultyLevel(editData.difficulty_name || "");
      setComprehensionPassage(editData.passage_text || "");
      setComprehensionQuestions(editData.subQuestions || []);
      // When editing, if editData has images, set the URL
      if (editData.images && editData.images.length > 0) {
        setDiagramImageUrl(editData.images[0]); // Assuming one image per question for now
      } else {
        setDiagramImageUrl("");
      }
      setShowModal(true);
    } else {
      resetForm(); // <- Call this to clean form if editData is null
    }
  }, [editData]);

  // Effect to fetch master data (question types, difficulty levels)
  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        // Actual API calls to fetch question types
        const qTypesResponse = await axios.get(`${getQuestionTypes}`, {
          headers: apiKeyHeader(),
        });
        const qTypes = qTypesResponse?.data || [];
        // const qTypes = await qTypesResponse.json();

        // Actual API calls to fetch difficulty levels
        const dLevelsResponse = await axios.get(`${getDifficultyLevels}`, {
          headers: apiKeyHeader(),
        });
        const dLevels = dLevelsResponse?.data || [];
        // const dLevels = await dLevelsResponse.json();

        // Update state with fetched question types
        setFetchedQuestionTypes(qTypes);
        if (qTypes.length > 0) {
          setQuestionType(qTypes[0].type_name);
          setCompQuestionType(qTypes[0].type_name);
        }

        // Update state with fetched difficulty levels
        setFetchedDifficultyLevels(dLevels);
        if (dLevels.length > 0) {
          setDifficultyLevel(dLevels[0].difficulty_name);
        }
      } catch (error) {
        console.error("Error fetching master data:", error);
        setErrorMasterData(`Failed to load master data: ${error.message}`);
      } finally {
        setLoadingMasterData(false);
      }
    };

    fetchMasterData();
  }, []);

  // Helper to process options (mark correct with '*')
  const processOptions = (rawOptions) => {
    return rawOptions
      .filter((opt) => opt.trim() !== "")
      .map((opt) => {
        const isCorrect = opt.startsWith("*");
        const text = isCorrect ? opt.substring(1).trim() : opt.trim();
        return { text, is_correct: isCorrect };
      });
  };

  // Helper to get type ID from type name
  const getQuestionTypeId = (typeName) => {
    const type = fetchedQuestionTypes.find((q) => q.type_name === typeName);
    return type ? type.type_id : null;
  };

  // Helper to get difficulty ID from level name
  const getDifficultyId = (levelName) => {
    const difficulty = fetchedDifficultyLevels.find(
      (d) => d.difficulty_name === levelName
    );
    return difficulty ? difficulty.difficulty_id : null;
  };

  // Handlers for input changes
  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleCompOptionChange = (index, value) => {
    const updated = [...compOptions];
    updated[index] = value;
    setCompOptions(updated);
  };

  // Add sub-question for comprehension
  const handleAddCompQuestion = () => {
    if (compQuestionText.trim() === "") {
      setMessage("Please enter sub-question text.");
      setMessageType("error");
      return;
    }

    const processedCompOptions = processOptions(compOptions);
    if (
      (compQuestionType === "Multiple Choice Single Correct" ||
        compQuestionType === "Multiple Choice Multiple Correct") &&
      processedCompOptions.length === 0
    ) {
      setMessage(
        "Multiple choice sub-question must have at least one valid option."
      );
      setMessageType("error");
      return;
    }

    const newCompQ = {
      id: Date.now(), // Client-side ID for list rendering
      type: compQuestionType,
      question: compQuestionText.trim(),
      options:
        compQuestionType === "Multiple Choice Single Correct" ||
        compQuestionType === "Multiple Choice Multiple Correct"
          ? processedCompOptions
          : [],
      marks: 1, // Default marks for sub-questions
    };

    setComprehensionQuestions((prev) => [...prev, newCompQ]);
    setCompQuestionText("");
    setCompOptions(["", "", "", ""]);
    setCompQuestionType(
      fetchedQuestionTypes.length > 0 ? fetchedQuestionTypes[0].type_name : ""
    );
    setMessage("Sub-question added successfully!");
    setMessageType("info");
  };

  // Handle form submission for single/comprehension questions
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setMessageType("");

    const selectedQuestionTypeId = getQuestionTypeId(questionType);
    const selectedDifficultyId = getDifficultyId(difficultyLevel);
    if (!selectedQuestionTypeId || !selectedDifficultyId) {
      setMessage("Please select valid Question Type and Difficulty Level.");
      setMessageType("error");
      return;
    }

    if (!selectedClassId || !selectedSubjectId || !selectedChapterId) {
      setMessage("Please select Class, Subject, and Chapter.");
      setMessageType("error");
      return;
    }

    const payloadBase = {
      questionType: selectedQuestionTypeId,
      difficulty_id: selectedDifficultyId,
      created_by: userId,
      class_id: parseInt(selectedClassId),
      subject_id: parseInt(selectedSubjectId),
      chapter_id: parseInt(selectedChapterId),
      images: diagramImageUrl ? [diagramImageUrl] : [],
    };
    console.log("payloadBase", payloadBase);

    let finalPayload;

    if (questionType === "Comprehension Parent") {
      if (!comprehensionPassage.trim() || comprehensionQuestions.length === 0) {
        setMessage("Enter passage and at least one sub-question.");
        setMessageType("error");
        return;
      }

      finalPayload = {
        ...payloadBase,
        question_id: editData?.question_id,
        question_text: questionText.trim(),
        passage_text: comprehensionPassage.trim(),
        group_stat: "parent",
        marks: 0,
        subQuestions: comprehensionQuestions.map((q) => ({
          question_text: q.question,
          questionType: getQuestionTypeId(q.type),
          options: q.options,
          difficulty_id: selectedDifficultyId,
          marks: q.marks || 1,
          group_stat: "child",
          link_id: null,
        })),
      };
    } else if (questionType === "Comprehension") {
      finalPayload = {
        ...payloadBase,
        question_id: editData?.question_id,
        question_text: "",
        passage_text: comprehensionPassage.trim(),
        group_stat: null,
        marks: 0,
        subQuestions: comprehensionQuestions.map((q) => ({
          question_text: typeof q === "string" ? q : q.question_text,
          questionType: getQuestionTypeId("Short Answer"),
          options: [],
          difficulty_id: selectedDifficultyId,
          marks: 1,
          group_stat: "child",
          link_id: null,
        })),
      };
    } else if (questionType === "Match the Following") {
      const validPairs = matchingPairs.filter(
        (pair) => pair.column1_text.trim() && pair.column2_text.trim()
      );
      if (validPairs.length === 0) {
        setMessage("Please add valid matching pairs.");
        setMessageType("error");
        return;
      }

      finalPayload = {
        ...payloadBase,
        question_id: editData?.question_id,
        question_text: questionText.trim(),
        questionType: 16,
        matching_options: validPairs.map((pair, idx) => ({
          column1_text: pair.column1_text.trim(),
          column2_text: pair.column2_text.trim(),
          match_sort_order: idx + 1,
        })),
      };
    } else {
      const processedOpts = processOptions(options);
      if (
        (questionType === "Multiple Choice Single Correct" ||
          questionType === "Multiple Choice Multiple Correct") &&
        processedOpts.length === 0
      ) {
        setMessage("Add at least one valid option.");
        setMessageType("error");
        return;
      }

      finalPayload = {
        ...payloadBase,
        question_id: editData?.question_id,
        question_text: questionText.trim(),
        options: processedOpts,
        marks: 1,
        passage_text: null,
        group_stat: null,
        link_id: null,
        created_by: userId,
      };
    }

    try {
      setIsProcessing(true);
      if (editData?.question_id) {
        await dispatch(
          editQuestionThunk({
            questionPayload: finalPayload,
            classId: selectedClassId,
            subjectId: selectedSubjectId,
            chapterId: selectedChapterId,
            userId: userId,
          })
        ).unwrap();
        dispatch(setEditingQuestion(null)); // optional
        dispatch(
          fetchQuestionsThunk({
            classId: selectedClassId,
            subjectId: selectedSubjectId,
            chapterId: selectedChapterId,
            created_by: userId,
          })
        );
        alert("Updated Succesfully");
        setMessage("Question updated successfully!");
        setMessageType("success");
      } else {
        //debugger;
        await dispatch(
          addQuestionThunk({
            questionData: finalPayload,
            classId: selectedClassId,
            subjectId: selectedSubjectId,
            chapterId: selectedChapterId,
            created_by: userId,
          })
        ).unwrap();
        dispatch(
          fetchQuestionsThunk({
            classId: selectedClassId,
            subjectId: selectedSubjectId,
            chapterId: selectedChapterId,
            created_by: userId,
          })
        );
        alert("Question Added successfully");
        setMessage("Question added successfully!");
        setMessageType("success");
      }

      setMessageType("success");
      resetForm();
    } catch (err) {
      console.error("Error:", err);
      alert(err);
      setMessage(err || "Failed to process the question.");
      setMessageType("error");
    } finally {
      setIsProcessing(false);
    }
  };

  // Handler for file selection
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setMessage(null); // Clear previous messages
  };

  // Parser for HTML content
  const parseWordHtmlForQuestions = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    const questions = [];

    const questionTables = doc.querySelectorAll(
      'table[style*="width: 100.013%; border-color: #ffffff; border-style: hidden;"]'
    );

    questionTables.forEach((table) => {
      const questionTextElement = table.querySelector("td:first-child span");
      if (questionTextElement && questionTextElement.innerText.includes("Q.")) {
        const questionText = questionTextElement.innerText
          .replace("Q.", "")
          .trim();
        const currentOptions = [];

        // Look for the <p> element immediately following this table
        let nextSibling = table.nextElementSibling;
        while (
          nextSibling &&
          nextSibling.tagName === "P" &&
          nextSibling.style.paddingLeft === "40px"
        ) {
          const rawOptionsText = nextSibling.innerHTML;
          const optionLines = rawOptionsText.split(/<br\s*\/?>/i);

          optionLines.forEach((line, idx) => {
            const cleanLine = line.replace(/<span[^>]*>|<\/span>/g, "").trim();
            if (cleanLine) {
              const optionMatch = cleanLine.match(/^([a-d]\)\s*)(.*)/i);
              const optionText = optionMatch
                ? optionMatch[2].trim()
                : cleanLine;
              currentOptions.push({ text: optionText, is_correct: idx === 0 });
            }
          });
          nextSibling = nextSibling.nextElementSibling;
        }

        questions.push({
          question_text: questionText,
          options: currentOptions,
          questionType: getQuestionTypeId("Multiple Choice Single Correct"),
          difficulty_id: getDifficultyId(difficultyLevel),
          marks: 1,
          created_by: userId,
          passage_text: null,
          group_stat: null,
          link_id: null,
          images: [],
        });
      }
    });
    return questions;
  };

  // Parser for raw text content
  const parseRawTextForQuestions = (rawTextContent) => {
    const questions = [];
    const questionBlocks = rawTextContent
      .split(/\s*Q\.\s*/)
      .filter((block) => block.trim() !== "");

    questionBlocks.forEach((block) => {
      const lines = block
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line !== "");
      if (lines.length === 0) return;

      const questionText = lines[0];
      const currentOptions = [];

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i];
        const optionMatch = line.match(/^([a-d])\)\s*(.*)/i);
        if (optionMatch) {
          const optionText = optionMatch[2].trim();
          currentOptions.push({
            text: optionText,
            is_correct: optionMatch[1].toLowerCase() === "a",
          });
        } else {
          break;
        }
      }

      if (questionText) {
        questions.push({
          question_text: questionText,
          options: currentOptions,
          questionType: getQuestionTypeId("Multiple Choice Single Correct"),
          difficulty_id: getDifficultyId(difficultyLevel),
          marks: 1,
          created_by: userId,
          passage_text: null,
          group_stat: null,
          link_id: null,
          images: [],
        });
      }
    });
    return questions;
  };

  // Handler for uploading the file
  // const handleUploadFile = () => {
  //   if (!selectedFile) {
  //     setMessage("Please select a file to upload.");
  //     setMessageType("error");
  //     return;
  //   }

  //   setUploading(true);
  //   setMessage("Processing file...");
  //   setMessageType("info");

  //   const reader = new FileReader();

  //   reader.onload = async (e) => {
  //     try {
  //       let parsedQuestions = [];

  //       if (
  //         selectedFile.name.endsWith(".html") ||
  //         selectedFile.name.endsWith(".htm")
  //       ) {
  //         const htmlContent = e.target.result;
  //         parsedQuestions = parseWordHtmlForQuestions(htmlContent);
  //       } else if (
  //         selectedFile.name.endsWith(".docx") ||
  //         selectedFile.name.endsWith(".doc")
  //       ) {
  //         const arrayBuffer = e.target.result;
  //         const result = await mammoth.extractRawText({ arrayBuffer });
  //         parsedQuestions = parseRawTextForQuestions(result.value);
  //       } else {
  //         setMessage(
  //           "Unsupported file type. Please upload .html, .htm, .docx, or .doc files."
  //         );
  //         setMessageType("error");
  //         setUploading(false);
  //         return;
  //       }

  //       if (parsedQuestions.length > 0) {
  //         console.log("Parsed Questions:", parsedQuestions);
  //         if (onAddQuestionsFromFile) {
  //           onAddQuestionsFromFile(parsedQuestions);
  //           setMessage(
  //             `Successfully added ${parsedQuestions.length} questions from file!`
  //           );
  //           setMessageType("success");
  //           setSelectedFile(null);
  //         } else {
  //           setMessage(
  //             "onAddQuestionsFromFile prop is not provided to handle parsed questions."
  //           );
  //           setMessageType("error");
  //         }
  //       } else {
  //         setMessage(
  //           "No questions could be extracted from the file. Please ensure it has the expected format."
  //         );
  //         setMessageType("error");
  //       }
  //     } catch (error) {
  //       console.error("Error parsing file:", error);
  //       setMessage(
  //         `Error parsing file: ${error.message}. Please ensure it's a valid file with the expected structure.`
  //       );
  //       setMessageType("error");
  //     } finally {
  //       setUploading(false);
  //     }
  //   };

  //   reader.onerror = () => {
  //     setMessage("Failed to read file.");
  //     setMessageType("error");
  //     setUploading(false);
  //   };

  //   if (
  //     selectedFile.name.endsWith(".docx") ||
  //     selectedFile.name.endsWith(".doc")
  //   ) {
  //     reader.readAsArrayBuffer(selectedFile);
  //   } else {
  //     reader.readAsText(selectedFile);
  //   }
  // };

  // if (loadingMasterData) {
  //   return (
  //     <div className="text-center p-8 text-lg">
  //       Loading question types and difficulty levels...
  //     </div>
  //   );
  // }

  if (errorMasterData) {
    return (
      <div className="text-center p-8 text-lg text-red-600">
        Error: {errorMasterData}
      </div>
    );
  }
  // const optionsNew = questionTypes.map((type) => ({
  //   value: type.type_id.toString(),
  //   label: type.type_name,
  // }));

  return (
    <div className=" mx-auto font-sans ">
      <MessageBox
        message={message}
        type={messageType}
        onClose={() => setMessage(null)}
      />
      <div className=" text-end w-100 text-end">
        <button
          disabled={
            !(selectedClassId && selectedSubjectId && selectedChapterId)
          }
          onClick={() => setShowModal(true)}
          style={{
            margin: "0",
            backgroundColor:
              selectedClassId && selectedSubjectId && selectedChapterId
                ? "#0d6efd"
                : "#6c757d", // blue if enabled, gray if disabled
            color: "#fff",
            border: "none",
            padding: "0.375rem 0.75rem",
            borderRadius: "0.25rem",
            cursor:
              selectedClassId && selectedSubjectId && selectedChapterId
                ? "pointer"
                : "not-allowed",
            opacity:
              selectedClassId && selectedSubjectId && selectedChapterId
                ? 1
                : 0.65,
          }}
        >
          + Add Question
        </button>
      </div>
      {/* Manual Question Entry Form */}
      {showModal && (
        <Popup
          title="Add New Question"
          onClose={() => {
            setShowModal(false);
            resetForm();
          }}
          style={{ overflow: "auto" }}
          maxWidth="700px"
          minHeight="400px"
        >
          <form
            onSubmit={handleSubmit}
            className="mb-8 p-3 w-100 border border-gray-200 rounded-lg bg-gray-50 shadow-md"
          >
            {/* <h2 className="text-2xl font-bold mb-6 text-gray-800">Add New Question</h2> */}
            <div className="row mb-3">
              <label
                htmlFor="questionType"
                className="block col-sm-3 col-form-label text-gray-700 font-bold "
              >
                Question Type:
              </label>
              <div className="col-sm-9">
                {/* <Select
                  options={optionsNew}
                  value={
                    optionsNew.find(
                      (opt) => opt.value === selectedQuestionTypeId
                    ) || null
                  }
                  onChange={(selected) => {
                    const name = "questionType";
                    const value = selected ? selected.value : ""; // if cleared, set to ""
                    // handleOnChange({ target: { name, value } });
                    setSelectedQuestionTypeId(value); // update local state or Redux
                  }}
                  placeholder="Select Question Type"
                /> */}
                <select
                  id="questionType"
                  value={questionType}
                  onChange={(e) => setQuestionType(e.target.value)}
                  className="w-full p-2 form-control border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                >
                  {fetchedQuestionTypes.map((type) => (
                    <option key={type.type_id} value={type.type_name}>
                      {type.type_name.replace(/([A-Z])/g, " $1").trim()}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="difficultyLevel"
                className="block col-sm-3 col-form-label text-gray-700 font-bold "
              >
                Difficulty Level:
              </label>
              <div className="col-sm-9">
                <select
                  id="difficultyLevel"
                  value={difficultyLevel}
                  onChange={(e) => setDifficultyLevel(e.target.value)}
                  className="w-full p-2 border border-gray-300 form-control rounded-md focus:ring-blue-500 focus:border-blue-500"
                >
                  {fetchedDifficultyLevels.map((level) => (
                    <option
                      key={level.difficulty_id}
                      value={level.difficulty_name}
                    >
                      {level.difficulty_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* Image Upload Input */}
            <div className="row mb-3">
              <label
                htmlFor="diagramImage"
                className="block col-sm-3 col-form-label text-gray-700 font-bold "
              >
                Diagram Image:
              </label>
              <div className="col-sm-9">
                <input
                  id="diagramImage"
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  disabled={imageUploading} // Disable while uploading
                />
                {diagramImageUrl && (
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">Image Preview:</p>
                    <img
                      src={diagramImageUrl}
                      alt="Diagram Preview"
                      className="max-w-xs h-auto rounded-md border"
                    />
                  </div>
                )}
                {imageUploading && (
                  <p className="text-sm text-blue-600">Uploading image...</p>
                )}
              </div>
            </div>
            {questionType === "Comprehension Parent" ? (
              <>
                <div className="row mb-3">
                  <label
                    htmlFor="comprehensionTitle"
                    className="block text-gray-700 col-sm-12 mb-0 col-form-label font-bold "
                  >
                    Comprehension Title/Summary (Optional):
                  </label>
                  <div className="col-sm-12">
                    <input
                      id="comprehensionTitle"
                      type="text"
                      value={questionText}
                      onChange={(e) => setQuestionText(e.target.value)}
                      placeholder="Enter a title or summary for the passage"
                      className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <label
                    htmlFor="comprehensionPassage"
                    className="block text-gray-700 col-sm-12 col-form-label font-bold "
                  >
                    Add Comprehension Passage:
                  </label>
                  <div className="col-sm-12">
                    <textarea
                      id="comprehensionPassage"
                      value={comprehensionPassage}
                      onChange={(e) => setComprehensionPassage(e.target.value)}
                      placeholder="Enter comprehension passage"
                      rows={6}
                      className="w-full col-sm-12 p-2 border border-gray-300 rounded-md resize-y focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <h4 className="text-lg text-center font-semibold mb-2 text-gray-700">
                  Add Sub-Questions for Comprehension
                </h4>
                <div className="row mb-3">
                  <label
                    htmlFor="compQuestionType"
                    className="block col-sm-4 col-form-label text-gray-700 font-bold "
                  >
                    Sub-Question Type:
                  </label>
                  <div className="col-sm-8">
                    <select
                      id="compQuestionType"
                      value={compQuestionType}
                      onChange={(e) => setCompQuestionType(e.target.value)}
                      className="w-full p-2 form-control border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    >
                      {fetchedQuestionTypes.map((type) => (
                        <option key={type.type_id} value={type.type_name}>
                          {type.type_name.replace(/([A-Z])/g, " $1").trim()}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <label
                    htmlFor="compQuestionText"
                    className="block col-sm-12 col-form-label text-gray-700 font-bold "
                  >
                    Sub-Question Text:
                  </label>
                  <div className="col-sm-12">
                    <input
                      id="compQuestionText"
                      type="text"
                      value={compQuestionText}
                      onChange={(e) => setCompQuestionText(e.target.value)}
                      placeholder="Enter sub-question text"
                      className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                {(compQuestionType === "Multiple Choice Single Correct" ||
                  compQuestionType === "Multiple Choice Multiple Correct") && (
                  <div className="row mb-3">
                    <label className="block text-gray-700 col-sm-12 col-form-label font-bold ">
                      Options (Prefix correct with *):
                    </label>
                    {compOptions.map((option, index) => (
                      <div className="col-sm-12 mb-2" key={index}>
                        <input
                          type="text"
                          value={option}
                          onChange={(e) =>
                            handleCompOptionChange(index, e.target.value)
                          }
                          placeholder={`Option ${index + 1}`}
                          className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    ))}
                  </div>
                )}
                <button
                  type="button"
                  style={{
                    margin: "0",
                    backgroundColor: "#0d6efd", // Bootstrap primary color
                    color: "#fff",
                    border: "none",
                    padding: "0.375rem 0.75rem",
                    borderRadius: "0.25rem",
                    cursor: "pointer",
                  }}
                  // className="btn m-0 btn-primary"
                  onClick={handleAddCompQuestion}
                  // className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                >
                  Add Sub-Question
                </button>

                <div className="mt-6">
                  <h5 className="text-md font-semibold mb-2">
                    Current Sub-Questions:
                  </h5>
                  {comprehensionQuestions.length === 0 ? (
                    <p className="text-gray-500">No sub-questions added yet.</p>
                  ) : (
                    <ul className="list-disc pl-5">
                      {comprehensionQuestions.map((subQ, index) => (
                        <li key={subQ.id} className="text-gray-700 mb-1">
                          <strong>
                            {index + 1}. (
                            {subQ.type.replace(/([A-Z])/g, " $1").trim()}):
                          </strong>{" "}
                          {subQ.question}
                          {subQ.options.length > 0 && (
                            <ul className="list-circle pl-5 text-sm">
                              {subQ.options.map((opt, optIndex) => (
                                <li
                                  key={optIndex}
                                  className={
                                    opt.is_correct
                                      ? "font-semibold text-green-700"
                                      : ""
                                  }
                                >
                                  {opt.text} {opt.is_correct && "(Correct)"}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </>
            ) : questionType === "Comprehension" ? (
              <>
                {/* Comprehension Passage */}
                <div className="row mb-3">
                  <label
                    htmlFor="comprehensionPassage"
                    className="block col-sm-12 col-form-label text-gray-700 font-bold"
                  >
                    Comprehension Passage:
                  </label>
                  <div className="col-sm-12">
                    <textarea
                      id="comprehensionPassage"
                      value={comprehensionPassage}
                      onChange={(e) => setComprehensionPassage(e.target.value)}
                      placeholder="Enter comprehension passage"
                      rows={6}
                      className="w-full p-2 border form-control border-gray-300 rounded-md resize-y focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>

                {/* Dynamic Sub-Questions */}
                <div className="row mb-3">
                  <label className="block col-sm-12 col-form-label text-gray-700 font-bold">
                    Sub-Questions:
                  </label>
                  {comprehensionQuestions.map((subQ, index) => (
                    <div
                      key={index}
                      style={{ display: "flex" }}
                      className="col-sm-12 mb-2 flex items-center gap-2"
                    >
                      <input
                        type="text"
                        value={subQ.question_text}
                        onChange={(e) =>
                          handleSubQuestionChange(index, e.target.value)
                        }
                        placeholder={`Sub-question ${index + 1}`}
                        className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                      />
                      <button
                        type="button"
                        style={{
                          margin: "0",
                          backgroundColor: "red", // Bootstrap primary color
                          color: "#fff",
                          border: "none",
                          padding: "0.375rem 0.75rem",
                          borderRadius: "0.25rem",
                          cursor: "pointer",
                        }}
                        onClick={() => removeSubQuestion(index)}
                        // className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                      >
                        ✕
                      </button>
                    </div>
                  ))}

                  <button
                    type="button"
                    style={{
                      margin: "0",
                      backgroundColor: "#0d6efd", // Bootstrap primary color
                      color: "#fff",
                      border: "none",
                      padding: "0.375rem 0.75rem",
                      borderRadius: "0.25rem",
                      cursor: "pointer",
                    }}
                    onClick={addSubQuestion}
                    className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                  >
                    + Add Sub-Question
                  </button>
                </div>
              </>
            ) : questionType === "Match the Following" ? (
              <>
                <div className="p-4 max-w-xl mx-auto">
                  <div className="mb-4">
                    <label className="block text-gray-700 font-semibold mb-1">
                      Question Text:
                    </label>
                    <input
                      type="text"
                      value={questionText}
                      onChange={(e) => setQuestionText(e.target.value)}
                      placeholder="Enter your question..."
                      className="w-full p-2 border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {matchingPairs.map((pair, index) => (
                    <div key={index} className="flex gap-4 mb-2">
                      <input
                        type="text"
                        placeholder={`Column A - ${index + 1}`}
                        value={pair.column1_text}
                        onChange={(e) =>
                          handleChange(index, "column1_text", e.target.value)
                        }
                        className="w-1/2 p-2 border border-gray-300 rounded"
                      />
                      <input
                        type="text"
                        placeholder={`Column B - ${index + 1}`}
                        value={pair.column2_text}
                        onChange={(e) =>
                          handleChange(index, "column2_text", e.target.value)
                        }
                        className="w-1/2 p-2 border border-gray-300 rounded"
                      />
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={addNewPair}
                    style={{
                      margin: "0",
                      backgroundColor: "#0d6efd", // Bootstrap primary color
                      color: "#fff",
                      border: "none",
                      padding: "0.375rem 0.75rem",
                      borderRadius: "0.25rem",
                      cursor: "pointer",
                    }}
                    // className="mt-2 px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    ➕ Add Pair
                  </button>

                  {/* <button
                    type="button"
                    onClick={handleSubmit}
                    className="mt-4 ml-3 px-4 py-2 bg-green-600 text-white rounded"
                  >
                    💾 Submit
                  </button> */}
                </div>
              </>
            ) : (
              <>
                <div className="row mb-3">
                  <label
                    htmlFor="questionText"
                    className="block col-sm-12 col-form-label text-gray-700 font-bold "
                  >
                    Question Text:
                  </label>
                  <div className="col-sm-12">
                    <textarea
                      id="questionText"
                      value={questionText}
                      onChange={(e) => setQuestionText(e.target.value)}
                      placeholder="Enter question text"
                      rows={4}
                      className="w-full p-2 border form-control border-gray-300 rounded-md resize-y focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                </div>
                {(questionType === "Multiple Choice Single Correct" ||
                  questionType === "Multiple Choice Multiple Correct") && (
                  <div className="row mb-3">
                    <label className="block col-sm-12 col-form-label text-gray-700 font-bold ">
                      Options (Prefix correct with *):
                    </label>
                    {options.map((option, index) => (
                      <div className="col-sm-12 mb-2" key={index}>
                        <input
                          type="text"
                          value={option}
                          onChange={(e) =>
                            handleOptionChange(index, e.target.value)
                          }
                          placeholder={`Option ${index + 1}`}
                          className="w-full p-2 border form-control border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
            <button
              type="submit"
              style={{
                backgroundColor: "rgb(4, 124,252)",
                border: "none",
                borderRadius: "5px",
              }}
              className="px-6 py-3 mt-4 font-semibold rounded-md bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {editData ? "Update Question" : "Add Question"}
            </button>
            <button
              style={{
                backgroundColor: "rgb(4, 124,252)",
                border: "none",
                borderRadius: "5px",
                color: "white",
              }}
              type="button"
              onClick={resetForm}
              className="px-6 py-3 mt-4 ms-2 font-semibold rounded-md bg-gray-300 text-gray-800 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Cancel
            </button>
          </form>
        </Popup>
      )}
    </div>
  );
};

export default AddQuestionForm;
